// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"c03901e6","102":"c62c8e35","325":"7951181c","405":"00b4af78","458":"ebd9d336","477":"2288b8c4","710":"6dd69825","739":"80475dd9","818":"5ec2ea99","865":"e29d3b16","912":"51db7db3","944":"da726481"}[chunkId] + ".chunk.js";
};